var bindCardLen;
var scnowitham;
var scwitham;
var UsepayCard;
var payMon;
var cashAcctid;
var pqdzDate; //普通取现到账日期
var outAmount; //快速取现剩余次数
var outMoney; //快速取现剩余金额

var bankimg; //银行卡图片链接
var bracna; //银行名称
var cardType; //银行卡类型

var withdrawTypeKey = "QUICK_CASH";
var appointCashMix = 0; //预约取现最小可取金额

var backto = ""; //返回页面判断
var defaultCardActivate = false; //默认选中卡是否待激活或待签约 false：已绑卡 true:待激活
var defaultActivateFlag = "1";
var defaultisExistsAgreement = "1";
var defaultCardno = "";
var flag = false;
var defaultNum = 0; //默认选中的行号
var curCardno = "";
var curIsExistsAgreement = "";
var curActivateFlag = "";

var bookType = "01"; //预约取现类型 单次01，周期02
var bookDay = "01"; //预约日
var bookMonth = "01"; //预约月
var nextincomeday;

var bindCardInfos;
var singleDate;
var surplusAmount = 0; //剩余钱包基金快取额度
var quickFundNum;
var cashLimit;
var walletWitham = 0; //钱包余额
var isEnable;
var EnumDrawLevelMsg = {
  0: "可取钱包全部金额",
  1: "可取本卡充值金额",
  2: "本卡不可取现",
};

$(function () {
  initDateData();
  var gep = getParamsByName("backto");
  if (!isNull(gep)) {
    backto = gep; //walletf
  }
  var params = {
    fundCode: "000905",
    shareType: "0",
    transCode: "02402",
    taNo: "R6",
  };
  toApi_toAc("S091502/", params, function (data) {
    surplusAmount = data.dayLeftShare;
    quickFundNum = data.quickFundNum;
    cashLimit = data.cashLimit;
  });

  toApi(
    "assetinformation.tml",
    function (data) {
      walletWitham = data.walamt;
    },
    "assetinformation",
    ""
  );

  //通过[获取绑定银行卡]接口获取用户充值所用银行卡信息
  getBankInfo();

  //通过[获取收益计算到账时间]接口获取收益计算日期和收益到账日期
  toApi(
    "getTransDate.tml?subjectCode=D02202&fundCode=000905",
    function (data) {
      pqdzDate = data.dateList[0];
    },
    "getTransDate",
    "000905"
  );

  $("#hotProductsRecommend").addClass("none");
  setHotRecommend();
});

function selOnCard(
  t_cardno,
  activateFlag,
  isExistsAgreement,
  i,
  r,
  nowitham,
  caid,
  witham,
  bankna,
  cardNo
) {
  //如果赋值的witham大于配置表里面的最大快速取现金额，则赋值为配置表中的最大快速取现金额
  if (Number(witham) > Number(outMoney)) {
    scwitham = outMoney;
  } else {
    scwitham = witham;
  }
  if (r > 0) {
    for (var t = 0; t < r; t++) {
      var boxt = "#box" + t;
      $(boxt).removeClass("active");
    }
  }

  var hcarno = "#hcarno" + i;
  var hbankimg = "#hbankimg" + i;
  var hcardtype = "#hcardtype" + i;
  var hbracna = "#hbracna" + i;
  UsepayCard = $(hcarno).val();
  bankimg = $(hbankimg).val(); //银行图片链接
  cardType = $(hcardtype).val(); //银行卡类型
  bracna = $(hbracna).val(); //银行卡名称
  scnowitham = nowitham;
  cashAcctid = caid;
  var box = "#box" + i;
  $(box).addClass("active");
  window.saveValue("cardNo", cardNo, false);
  window.saveValue("cardNa", bankna, false);

  defaultCardActivate = false;

  curCardno = t_cardno;
  curIsExistsAgreement = isExistsAgreement;
  curActivateFlag = activateFlag;
}
function before() {
  closeKeypad();
  $("#paySc").val("");
  $("#r2").addClass("none");
  $("#r1").removeClass("none");
  $("#n2").addClass("none");
  $("#n1").removeClass("none");
  $("#h2").removeClass("active");
  $("#h1").addClass("active");
}
function back() {
  // window.location.href=phURL + "wallet/wallet.html";
  if (backto == "walletf") {
    window.location.href = phURL + "wallet/wallet.html";
  } else {
    history.back();
  }
}

function isString(num) {
  return Object.prototype.toString.apply(num) == "[object String]";
}

function next() {
  if (curActivateFlag == "0") {
    $("#spanTip").text("该银行卡还未激活，无法进行交易，是否立即激活？");
    $("#actionTip").text("立即激活");
    $("#noactiveCard").css("display", "block");
    return;
  } else if (curIsExistsAgreement == "0") {
    UsepayCard =
      UsepayCard.substring(0, 4) +
      "********" +
      UsepayCard.substring(UsepayCard.length - 4, UsepayCard.length);
  }

  payMon = $("#MonMath").val();
  if (isNull(payMon)) {
    errShow("MonMath", "取现金额还未输入，请先输入取现金额");
    return;
  }
  if (!checkAmt("MonMath", "")) {
    return;
  }
  if (withdrawTypeKey == "REGULAR_CASH") {
    //普通
    if (payMon > scnowitham) {
      // errShow('MonMath','取现金额不能大于此卡普通取现最大取现金额');
      errShow("MonMath", "取现金额不能大于此卡最大可取现金额");
      return;
    }
    scrollTo(0, 0);
    //$('#h1').removeClass('active');
    $("#h2").addClass("active");
    $("#r1").addClass("none");
    $("#r2").removeClass("none");
    $("#n1").addClass("none");
    $("#n2").removeClass("none");
    $("#tokeMsg").text("普通取现");
    $("#enBankImg").attr("src", bankimg);
    $("#enBranchName").text(bracna);
    $("#enCardType").text(getCardType(cardType));
    $("#secardno").text(UsepayCard);
    $("#MonMath2").text(toThousands(payMon, 2));
  } else if (withdrawTypeKey == "QUICK_CASH") {
    if ($("#agree").prop("checked")) {
      // do something
    } else {
      $("#e_agree").css("display", "block");
      return;
    }

    if (payMon > scwitham) {
      // errShow('MonMath','取现金额不能大于此卡快速取现最大取现金额');
      errShow("MonMath", "取现金额不能大于此卡最大可取现金额");
      return;
    }
    //通过[获取取现方式列表]接口获取快速取现次数和额度
    toApi(
      "getWithdrawType.tml",
      function (data) {
        for (var i = 0; i < data.outList.length; i++) {
          if (data.outList[i].key == "QUICK_CASH") {
            if (payMon > data.outList[i].drsuam) {
              $("#e_MonMath").removeClass("none");
              // $('#e_MonMath').html('<i class="ic-error"></i>取现金额不能大于此卡快速取现最大取现金额');
              $("#e_MonMath").html(
                '<i class="ic-error"></i>取现金额不能大于此卡最大可取现金额'
              );
            } else if (data.outList[i].drsutm <= 0) {
              $("#e_reg1").removeClass("none");
              $("#e_reg1").html(
                '<i class="ic-error"></i>您今日的快速取现次数已用完'
              );
            }
          } else {
            if (
              Number(payMon) > Number(surplusAmount) &&
              !isNull(cashLimit) &&
              !isNull(quickFundNum)
            ) {
              alertIknowEncMsg(
                "风险提示：鹏华A加钱包就安盈宝、添利宝、增值宝、兴鑫宝、金元宝、添利交易型货币、聚财通、盈余宝A类八只货基产品提供快速取现服务，快速取现服务不是法定义务，提现有条件，依约可暂停。到账时间以银行入账时间为准。单笔或当日累计快速取现金额超过" +
                  cashLimit +
                  "元时，投资者即授权同意将超出" +
                  cashLimit +
                  "元的份额转换为其他七只货币市场基金份额并进行快速取现，份额转换仍以投资者持有的单只货币市场基金单个自然日" +
                  cashLimit +
                  "元为限。"
              );
              return;
            }
            enchIm();
          }
        }
      },
      "enchashment",
      ""
    );
  } else if (withdrawTypeKey == "APPOINT_CASH") {
    if (!$("#agree").prop("checked")) {
      $("#e_agree").css("display", "block");

      return;
    }
    if (payMon < appointCashMix) {
      errShow("MonMath", "预约取现金额不能小于" + appointCashMix + "元");
      return;
    }
    if (Number(payMon) > Number(walletWitham)) {
      //输入金额大于钱包余额
      alertIknowEnMsg(
        "【友情提示】：当前钱包余额为" +
          walletWitham +
          "元，低于预约取现金额，请在预约取现发起时确保钱包有足够的余额。"
      );
    } else if (Number(payMon) > Number(scnowitham)) {
      //输入金额大于银行卡额度
      alertIknowEnMsg(
        "【友情提示】：您本次预约取现的银行卡流量为" +
          scnowitham +
          "元，低于预约取现金额，您可通过本卡对钱包进行充值，保证卡流量高于预约取现金额。"
      );
    } else {
      bookEnch();
    }
  }
}

function enchIm() {
  $("#popalert").remove();
  scrollTo(0, 0);
  $("#h2").addClass("active");
  $("#r1").addClass("none");
  $("#r2").removeClass("none");
  $("#n1").addClass("none");
  $("#n2").removeClass("none");
  $("#tokeMsg").text("快速取现");
  $("#enBankImg").attr("src", bankimg);
  $("#enBranchName").text(bracna);
  $("#enCardType").text(getCardType(cardType));
  $("#secardno").text(UsepayCard);
  $("#MonMath2").text(toThousands(payMon, 2));
}

function bookEnch() {
  $("#popalert").remove();
  bookMonth = $("#monthdiv .searchable-select-holder").html();
  if (bookMonth == "每月") {
    bookMonth == null;
  } else {
    bookMonth = bookMonth.replace("月", "");
    bookMonth = Number(bookMonth);
  }
  bookDay = $("#daydiv .searchable-select-holder").html();
  bookDay = bookDay.replace("日", "");
  bookDay = Number(bookDay);
  bookType =
    $("#bookTypediv .searchable-select-holder").html() == "单次" ? "01" : "02";

  toApi(
    "getnextbookdate.tml?timingCycle=" +
      bookType +
      "&timingDate=" +
      bookDay +
      "&bookMonth=" +
      bookMonth,
    function (data) {
      if (bookType == "02") {
        $("#nextTimingDay").html(
          "每月" +
            data.nextTimingDay.slice(8, 10) +
            "日" +
            data.nextTimingDay.slice(10)
        );
      } else {
        $("#nextTimingDay").html(data.nextTimingDay);
      }
      nextincomeday = data.nextTimingDay;
      scrollTo(0, 0);
      $("#h2").addClass("active");
      $("#r1").addClass("none");
      $("#r2").removeClass("none");
      $("#n1").addClass("none");
      $("#n2").removeClass("none");
      $("#nextgetdayLi").show();
      $("#tokeMsg").text("预约取现");
      $("#enBankImg").attr("src", bankimg);
      $("#enBranchName").text(bracna);
      $("#enCardType").text(getCardType(cardType));
      $("#secardno").text(UsepayCard);
      $("#MonMath2").text(toThousands(payMon, 2));
    }
  );
}

function alertIknowEncMsg(msg) {
  var alhtml =
    '<div class="tipMsgCover" id="popalert">' +
    '<div class="pup-box">' +
    '<img class="imgtips"  src="' +
    phURL +
    'images/tips/reg-tips-gt.jpg" style="margin: 35px 0 10px;">' +
    '<div class="tips-font1"><text class="">' +
    msg +
    "</text></div>" +
    '<p><a href="javascript:void(0)" class="btn-blue" onclick="enchIm()">我知道了</a></p>' +
    "</div>" +
    "</div>";
  $("body").append(alhtml);
}

/**
 * 弹出框，带一个"我知道了"按钮
 * @param msg: 需要展示的信息
 */
function alertIknowEnMsg(msg) {
  var alhtml =
    '<div class="tipMsgCover" id="popalert">' +
    '<div class="pup-box">' +
    '<img class="imgtips"  src="' +
    phURL +
    'images/tips/reg-tips-gt.jpg">' +
    '<div class="tips-font"><text>' +
    msg +
    "</text></div>" +
    '<p><a href="javascript:void(0)" class="btn-blue" onclick="bookEnch()">我知道了</a></p>' +
    "</div>" +
    "</div>";
  $("body").append(alhtml);
}

function withdraw() {
  closeKeypad();
  var paySc = $("#paySc").val();
  if (isNull(paySc)) {
    errShow("paySc", "交易密码还未输入，请先输入交易密码");
    return;
  } else {
    if (!checkTransPwd2("paySc", "交易密码不合法")) {
      errShow("paySc", "交易密码不能少于六位，请重新输入");
      return;
    }
    $("#e_paySc").addClass("none");
    $("#paySc").val("");
    //通过[密钥下发]接口获取密码RSA秘钥
    toApi(
      "getPubKey.tml?type=" + 2,
      function (data) {
        var drawType;
        if (withdrawTypeKey == "QUICK_CASH") {
          drawType = "1";
        } else if (withdrawTypeKey == "REGULAR_CASH") {
          drawType = "2";
        }
        var m_p = hex_md5(paySc);
        var publicKey = data.key;
        var encrypt = new JSEncrypt();
        encrypt.setPublicKey(publicKey);
        var r_p = encrypt.encrypt(m_p);

        if (withdrawTypeKey == "QUICK_CASH") {
          //通过[转出]接口对用户进行取现
          //             var signUrl='cardNo='+UsepayCard+'&cashAcctid='+cashAcctid+'&transAmt='+payMon+'&drawType='+drawType+'&transPwd='+r_p+'&dsactp=1&entrustWay=3&key=abc123';
          //             var sign=CryptoJS.MD5(signUrl);
          //通过[转出]接口对用户进行取现
          var params = {
            cashAcctId: cashAcctid,
            fundCode: "000905",
            occurShare: payMon,
            shareType: "0",
            transCode: "02402",
            taNo: "R6",
            transPwd: r_p,
          };
          toApi_toAcCg(
            "S091501",
            params,
            function (data) {
              if (data.state == 2 || data.state == "2") {
                $("#h3").addClass("active");
                $("#r2").addClass("none");
                $("#r5").removeClass("none");
                $("#r6").addClass("none");
                $("#n2").addClass("none");
                $("#n3").removeClass("none");
                $("#m1").addClass("none");
                $("#hotProductsRecommend").removeClass("none");
                return;
              } else if (data.state == 0 || data.state == "0") {
                $("#h3").addClass("active");
                $("#r2").addClass("none");
                $("#r6").removeClass("none");
                $("#r5").addClass("none");
                $("#n2").addClass("none");
                $("#n3").removeClass("none");
                $("#m1").addClass("none");
                $("#hotProductsRecommend").removeClass("none");
                return;
              } else {
                //$('#h2').removeClass('active');
                $("#h3").addClass("active");
                $("#r2").addClass("none");
                $("#r3").removeClass("none");
                $("#r4").removeClass("none");
                $("#n2").addClass("none");
                $("#n3").removeClass("none");
                $("#m1").addClass("none");
                $("#hotProductsRecommend").removeClass("none");
                $("#spnotanstime").text(data.transDate);
                var bankName = window
                  .loadValue("cardNa", false)
                  .replace(new RegExp(/(")/g), "");
                var bankCardNo = window
                  .loadValue("cardNo", false)
                  .replace(new RegExp(/(")/g), "");
                $("#bankName").text(
                  "(" + bankName + bankCardNo.slice(bankCardNo.length - 4) + ")"
                );
                $("#spnorecvDate").text("预计一分钟到账");
              }
            },
            "withdraw",
            "",
            function (data) {
              if (data.respCode == "0010" || data.respCode == "bf2087") {
                $("#h3").addClass("active");
                $("#r2").addClass("none");
                $("#r6").removeClass("none");
                $("#r5").addClass("none");
                $("#n2").addClass("none");
                $("#n3").removeClass("none");
                $("#m1").addClass("none");
                $("#hotProductsRecommend").removeClass("none");
                return;
              } else if (data.respCode != "000000") {
                showErrorMsg(data.respMsg, data.respType);
              }
            }
          );
        } else if (withdrawTypeKey == "REGULAR_CASH") {
          var params1 = {
            cashAcctId: cashAcctid,
            drawType: "2",
            transCode: "02401",
            transAmt: payMon,
            transPwd: r_p,
          };
          toApi_toAcCg(
            "S150040",
            params1,
            function (data) {
              if (data.state == "0") {
                $("#h3").addClass("active");
                $("#r2").addClass("none");
                $("#r3").removeClass("none");
                $("#r4").removeClass("none");
                $("#n2").addClass("none");
                $("#n3").removeClass("none");
                $("#m1").addClass("none");
                $("#hotProductsRecommend").removeClass("none");
                $("#spnotanstime").text(dateAndTimeFormat(data.orderTime));
                var bankName = window
                  .loadValue("cardNa", false)
                  .replace(new RegExp(/(")/g), "");
                var bankCardNo = window
                  .loadValue("cardNo", false)
                  .replace(new RegExp(/(")/g), "");
                $("#bankName").text(
                  "(" + bankName + bankCardNo.slice(bankCardNo.length - 4) + ")"
                );
                $("#spnorecvDate").text(data.capitalDate);
              } else if (data.state == "9") {
                $("#h3").addClass("active");
                $("#r2").addClass("none");
                $("#r6").removeClass("none");
                $("#r5").addClass("none");
                $("#n2").addClass("none");
                $("#n3").removeClass("none");
                $("#m1").addClass("none");
                $("#hotProductsRecommend").removeClass("none");
              }
            },
            "enchashment",
            "000905",
            function (err) {
              if (err && err.respData) {
                if (err.respData.state == "9") {
                  $("#h3").addClass("active");
                  $("#r2").addClass("none");
                  $("#r6").removeClass("none");
                  $("#r5").addClass("none");
                  $("#n2").addClass("none");
                  $("#n3").removeClass("none");
                  $("#m1").addClass("none");
                  $("#hotProductsRecommend").removeClass("none");
                } else if (err.respData.respMsg) {
                  showErrorMsg(err.respData.respMsg);
                } else {
                  $("#h3").addClass("active");
                  $("#r2").addClass("none");
                  $("#r6").removeClass("none");
                  $("#r5").addClass("none");
                  $("#n2").addClass("none");
                  $("#n3").removeClass("none");
                  $("#m1").addClass("none");
                  $("#hotProductsRecommend").removeClass("none");
                }
              } else if (err && err.respMsg) {
                showErrorMsg(err.respMsg);
              }
            }
          );
        } else if (withdrawTypeKey == "APPOINT_CASH") {
          toApi(
            "newbookplan2.tml?timingAmount=" +
              payMon +
              "&cashAcctid=" +
              cashAcctid +
              "&timingType=" +
              bookType +
              "&bookMonth=" +
              bookMonth +
              "&bookDay=" +
              bookDay +
              "&transPwd=" +
              r_p +
              "&singleDate=" +
              singleDate,
            function (data) {
              $("#h3").addClass("active");
              $("#r2").addClass("none");
              $("#r3").removeClass("none");
              $("#r3").html("预约取现新增成功");
              $("#r7").removeClass("none");
              $("#n2").addClass("none");
              $("#n3").removeClass("none");
              $("#m1").addClass("none");
              $("#hotProductsRecommend").removeClass("none");

              $("#jiming").html(
                data.prodName + "(" + getPersonalFundCode() + ")"
              );
              $("#banknameno").html(
                data.bankName +
                  "(尾号" +
                  data.bankcard.slice(data.bankcard.length - 4) +
                  ")"
              );
              $("#everydown").html(toThousands(data.transAmt, 2) + "元");
              if (bookType == "01") {
                $("#downday").html(nextincomeday);
                $("#everorone").html("单次取现：");
              } else {
                $("#downday").html(
                  "每月" +
                    nextincomeday.slice(8, 10) +
                    "日" +
                    nextincomeday.slice(10)
                );
                $("#everorone").html("每期取现：");
              }
            }
          );
        }
      },
      "getPubKey",
      ""
    );
  }
}
function gotoAddCard() {
  gotoAddmybindbankcard("?goback=1");
}

function allench(id) {
  if (withdrawTypeKey == "QUICK_CASH") {
    $("#" + id).val(scwitham.toFixed(2));
  } else if (withdrawTypeKey == "REGULAR_CASH") {
    $("#" + id).val(scnowitham.toFixed(2));
  }
}
function openagreement() {
  $("#wdoffervi").removeClass("none");
}
function goBindCard(cardno, isExistsAgreement, activateFlag) {
  localStorage.t_cardno = cardno;
  // gotoAddmybindbankcard("?older=1&isExistsAgreement="+isExistsAgreement+"&activateFlag="+activateFlag);
  combinedTip("需通过A加钱包APP进行操作");
}
function goDefaultBindCard() {
  goBindCard(curCardno, curIsExistsAgreement, curActivateFlag);
}
//获取取现方式列表
function getWithdrawType(data) {
  for (var t = 0; t < data.outList.length; t++) {
    var tst =
      "<div class='input-item manner' onclick='choseWithdrawType(\"" +
      data.outList[t].key +
      "\")' " +
      'id="wdType' +
      data.outList[t].key +
      '">' +
      data.outList[t].typeName +
      "<span class='ccor'>" +
      data.outList[t].profit +
      "</span>" +
      "<i></i>" +
      "</div>";
    $("#withdrawTypeChose").append(tst);

    if (data.outList[t].key == "APPOINT_CASH") {
      appointCashMix = data.outList[t].appointCashMix;
    }
  }
  $("#withdrawTypeChose").append(
    '<p class="tips none" id="e_reg1"><i class="ic-error"></i></p>'
  );
  choseWithdrawType("QUICK_CASH");
}
// var typekeyArray = ["QUICK_CASH","REGULAR_CASH","APPOINT_CASH"];
function choseWithdrawType(typekey) {
  if (typekey == "QUICK_CASH") {
    //快速取现
    $("#MonMath").attr("placeholder", "单日累计快取金额" + outMoney + "元");
    $("#tip").html("<div>预计<span>1分钟</span>内到账</div>");
    //	    $("#tip").html('<div>预计<span>1分钟</span>内到账，今日快速取现剩余次数<span>'+outAmount+'</span>次</div>');
    for (var i = 0; i < bindCardLen; i++) {
      if (Number(bindCardInfos[i].witham) > Number(outMoney)) {
        $("#spTokeMo" + i).text(toThousands(outMoney, 2) + "元");
      } else {
        $("#spTokeMo" + i).text(toThousands(bindCardInfos[i].witham, 2) + "元");
      }
      var spTokeVi = "#spTokeVi" + i;
      var noTokeVi = "#noTokeVi" + i;
      $(spTokeVi).removeClass("none");
      $(noTokeVi).addClass("none");
    }
    $("#wdTypeQUICK_CASH").addClass("active");
    $("#wdTypeREGULAR_CASH").removeClass("active");
    $("#wdTypeAPPOINT_CASH").removeClass("active");
    withdrawTypeKey = "QUICK_CASH";
    $("#agreementLi").removeClass("none");
    $("#agreeyq").hide();
    $("#agreekq").show();
    $("#agreekqHint").show();

    $("#bookMonthDay").hide();
    //全部取现按钮置蓝
    document.getElementById("allench").style.color = "#00a7fb";
    document.getElementById("allench").style.border = "1px solid #00a7fb";
  } else if (typekey == "REGULAR_CASH") {
    //普通取现
    $("#MonMath").attr("placeholder", "请输入金额");
    $("#tip").html("<div>预计 <span>" + pqdzDate + "</span> 到账</div>");
    for (var i = 0; i < bindCardLen; i++) {
      if (
        Number($("#spTokeMo" + i).text()) !=
        toThousands(bindCardInfos[i].normalWitham, 2) + "元"
      ) {
        $("#spTokeMo" + i).text(
          toThousands(bindCardInfos[i].normalWitham, 2) + "元"
        );
      }
      var spTokeVi = "#spTokeVi" + i;
      var noTokeVi = "#noTokeVi" + i;
      $(spTokeVi).addClass("none");
      $(noTokeVi).removeClass("none");
    }
    $("#wdTypeQUICK_CASH").removeClass("active");
    $("#wdTypeREGULAR_CASH").addClass("active");
    $("#wdTypeAPPOINT_CASH").removeClass("active");
    withdrawTypeKey = "REGULAR_CASH";
    $("#agreementLi").addClass("none");
    $("#bookMonthDay").hide();
    $("#agreekqHint").hide();

    //全部取现按钮置蓝
    document.getElementById("allench").style.color = "#00a7fb";
    document.getElementById("allench").style.border = "1px solid #00a7fb";
  } else if (typekey == "APPOINT_CASH") {
    //预约取现
    $("#MonMath").attr("placeholder", "请输入金额");
    $("#tip").html("");
    //	    $("#tip").html('预计到账时间  2016-07-06  16 : 00');
    for (var i = 0; i < bindCardLen; i++) {
      if (
        Number($("#spTokeMo" + i).text()) !=
        toThousands(bindCardInfos[i].normalWitham, 2) + "元"
      ) {
        $("#spTokeMo" + i).text(
          toThousands(bindCardInfos[i].normalWitham, 2) + "元"
        );
      }
      var spTokeVi = "#spTokeVi" + i;
      var noTokeVi = "#noTokeVi" + i;
      $(spTokeVi).removeClass("none");
      $(noTokeVi).addClass("none");
    }
    $("#wdTypeQUICK_CASH").removeClass("active");
    $("#wdTypeREGULAR_CASH").removeClass("active");
    $("#wdTypeAPPOINT_CASH").addClass("active");
    withdrawTypeKey = "APPOINT_CASH";
    $("#agreementLi").removeClass("none");
    $("#agreekq").hide();
    $("#agreekqHint").hide();

    $("#agreeyq").show();
    $("#bookMonthDay").show();
    //全部取现按钮置灰
    document.getElementById("allench").style.color = "#999999";
    document.getElementById("allench").style.border = "1px solid #ccd1d7";

    var mm = $("#monthdiv .searchable-select-holder").html();
    var bb = $("#daydiv .searchable-select-holder").html();

    if (mm == "每月") {
      mm = null;
    } else {
      mm = mm.replace("月", "");
      mm = Number(mm);
    }
    bb = bb.replace("日", "");
    bb = Number(bb);

    var showYear = $("#yeardiv .searchable-select-holder").html();
    var showMonth = $("#monthdiv .searchable-select-holder").html();
    var showDay = $("#daydiv .searchable-select-holder").html();
    singleDate =
      showYear.substr(0, showYear.length - 1) +
      showMonth.substr(0, showMonth.length - 1) +
      showDay.substr(0, showDay.length - 1);

    getNEXTTIMEDAY(bb, mm, singleDate);
  }
  if (isEnable == "Y") {
    for (var i = 0; i < bindCardInfos.length; i++) {
      if (bindCardInfos[i].isDefault == "1") {
        selOnCard(
          bindCardInfos[i].cardno,
          bindCardInfos[i].activateFlag,
          bindCardInfos[i].isExistsAgreement,
          i,
          bindCardInfos.length,
          bindCardInfos[i].normalWitham,
          bindCardInfos[i].cashAcctId,
          bindCardInfos[i].witham,
          bindCardInfos[i].brchna,
          bindCardInfos[i].cardno.substring(
            bindCardInfos[i].cardno.length - 4,
            bindCardInfos[i].cardno.length
          )
        );
      }
    }
  } else {
    selOnCard(
      bindCardInfos[0].cardno,
      bindCardInfos[0].activateFlag,
      bindCardInfos[0].isExistsAgreement,
      0,
      bindCardInfos.length,
      bindCardInfos[0].normalWitham,
      bindCardInfos[0].cashAcctid,
      bindCardInfos[0].witham,
      bindCardInfos[0].brchna,
      bindCardInfos[0].cardno.substring(
        bindCardInfos[0].cardno.length - 4,
        bindCardInfos[0].cardno.length
      )
    );
  }
}

//select选择监听
var the_month = "201";
var mouthArr = [
  "",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
];
function choseSelet(index) {
  setTimeout(function () {
    if (index == "102" || index == 102) {
      //预约取现类型 单次01，周期02
      bookType = "02";
      $("#yeardiv").hide();

      $("#monthdiv").html(
        '<select id="month">' +
          '<option value="401">每月</option>' +
          "</select>"
      );
      $("#month").searchableSelect();

      var dayHtml = '<select id="day">';
      for (var k = 1; k < mouthArr.length; k++) {
        dayHtml +=
          '<option value="3' + mouthArr[k] + '">' + mouthArr[k] + "日</option>";
      }
      dayHtml += "</select>";
      $("#daydiv").html(dayHtml);
      $("#day").searchableSelect();
    } else if (index == "101" || index == 101) {
      bookType = "01"; //预约取现类型 单次01，周期02
      $("#yeardiv").show();

      if (!isNull(baseDate)) {
        var yearHtml = '<select id="year">';
        for (var i = 0; i < baseDate.length; i++) {
          yearHtml +=
            '<option value="y' +
            baseDate[i].name +
            '">' +
            baseDate[i].name +
            "年</option>";
        }
        yearHtml += "</select>";
        $("#yeardiv").html(yearHtml);
        $("#year").searchableSelect();
        setMouth(baseDate[0].name);
      }
    }

    if (bookType == "01" && !isNull(baseDate)) {
      if (index.substr(0, 1) == "y") {
        //选择年设置月日
        setMouth(index.substr(1, index.length));
      }

      if (index.substr(0, 1) == "m") {
        //选择月设置日
        var last_year = $("#yeardiv .searchable-select-holder").html();
        last_year = last_year.substr(0, last_year.length - 1);
        var last_mouth = index.substr(1, index.length - 1);
        setDay(last_year, last_mouth);
      }
    }

    index = index.toString();
    if (index.slice(0, 1) == "2") {
      the_month = index;
    }

    if (bookType == "02") {
      //监听为周期，日期限制到28天
      $("#day329").hide();
      $("#day330").hide();
      $("#day331").hide();
      $("#monthdiv .searchable-select-holder").html("每月");
    } else if (
      bookType == "01" &&
      (the_month == "201" ||
        the_month == "203" ||
        the_month == "205" ||
        the_month == "207" ||
        the_month == "208" ||
        the_month == "210" ||
        the_month == "212")
    ) {
      //监听为单次，日期限制到31天
      $("#day329").show();
      $("#day330").show();
      $("#day331").show();
    } else if (
      bookType == "01" &&
      (the_month == "204" ||
        the_month == "206" ||
        the_month == "209" ||
        the_month == "211")
    ) {
      //监听为单次，日期限制到30天
      $("#day329").show();
      $("#day330").show();
      $("#day331").hide();
    } else if (bookType == "01" && the_month == "202") {
      //监听为单次，日期限制到28天
      $("#day329").hide();
      $("#day330").hide();
      $("#day331").hide();
    }

    if (
      bookType == "01" &&
      $("#monthdiv .searchable-select-holder").html() == "每月"
    ) {
      //
      $("#monthdiv .searchable-select-holder").html("01月");
    }
    var mm = $("#monthdiv .searchable-select-holder").html();
    var bb = $("#daydiv .searchable-select-holder").html();

    if (mm == "每月") {
      mm = null;
    } else {
      mm = mm.replace("月", "");
      mm = Number(mm);
    }
    bb = bb.replace("日", "");
    bb = Number(bb);
    if (index.slice(0, 1) == "2") {
      mm = index.slice(1, 3);
      mm = Number(mm);
    } else if (index.slice(0, 1) == "3") {
      bb = index.slice(1, 3);
      bb = Number(bb);
    }
    if (bookType == "01") {
      var showYear = $("#yeardiv .searchable-select-holder").html();
      var showMonth = $("#monthdiv .searchable-select-holder").html();
      var showDay = $("#daydiv .searchable-select-holder").html();
      singleDate =
        showYear.substr(0, showYear.length - 1) +
        showMonth.substr(0, showMonth.length - 1) +
        showDay.substr(0, showDay.length - 1);
    }
    getNEXTTIMEDAY(bb, mm, singleDate);
  }, 10);
}

function getNEXTTIMEDAY(bb, mm, singleDate) {
  toApi(
    "getnextbookdate2.tml?timingCycle=" +
      bookType +
      "&timingDate=" +
      bb +
      "&bookMonth=" +
      mm +
      "&singleDate=" +
      singleDate,
    function (data) {
      $("#tip").html(
        "<div>预计到账日期为  <span>" + data.nextTimingDay + "</span></div>"
      );
    }
  );
}

/**
 * 根据年、月设置日
 */
function setDay(year, mouth) {
  if (isNull(baseDate)) {
    return;
  }
  for (var i = 0; i < baseDate.length; i++) {
    if (baseDate[i].name == year) {
      for (var j = 0; j < baseDate[i].children.length; j++) {
        if (baseDate[i].children[j].name == mouth) {
          var dayHtml = '<select id="day">';
          for (var k = 0; k < baseDate[i].children[j].children.length; k++) {
            dayHtml +=
              '<option value="d' +
              baseDate[i].children[j].children[k] +
              '">' +
              baseDate[i].children[j].children[k] +
              "日</option>";
          }
          dayHtml += "</select>";
          $("#daydiv").html(dayHtml);
          $("#day").searchableSelect();
        }
      }
    }
  }
}

/**
 * 根据年设置月
 */
function setMouth(year) {
  if (isNull(baseDate)) {
    return;
  }
  var mouth;
  for (var i = 0; i < baseDate.length; i++) {
    if (baseDate[i].name == year) {
      mouth = baseDate[i].children[0].name;
      var monthHtml = '<select id="month">';
      for (var j = 0; j < baseDate[i].children.length; j++) {
        monthHtml +=
          '<option value="m' +
          baseDate[i].children[j].name +
          '">' +
          baseDate[i].children[j].name +
          "月</option>";
      }
      monthHtml += "</select>";
      $("#monthdiv").html(monthHtml);
      $("#month").searchableSelect();
    }
  }

  setDay(year, mouth);
}

/*
 * 要求：
 * 1.数据最少6个月；
 * 2.第一年的数据需要展示完整  :e.g(20180101开始  可选时间截止为20181231)
 */
var baseDate = []; //单次
//周期
var baseYearDate = [
  {
    name: "01",
    children: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
  },
  {
    name: "02",
    children: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
    ],
  },
  {
    name: "03",
    children: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
  },
  {
    name: "04",
    children: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
    ],
  },
  {
    name: "05",
    children: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
  },
  {
    name: "06",
    children: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
    ],
  },
  {
    name: "07",
    children: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
  },
  {
    name: "08",
    children: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
  },
  {
    name: "09",
    children: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
    ],
  },
  {
    name: "10",
    children: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
  },
  {
    name: "11",
    children: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
    ],
  },
  {
    name: "12",
    children: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ],
  },
];
var dateData = []; //日期数据
function initDateData(doFunc) {
  toApi("gett2date.tml?fund_code=" + getPersonalFundCode(), function (data) {
    var startDay;
    if (data.ist2 == 1) {
      startDay = data.t_add_two;
    } else {
      startDay = data.t_add_one;
    }

    var year = Number(startDay.substr(0, 4));
    var month = Number(startDay.substr(4, 2));
    var day = Number(startDay.substr(6, 2));

    //第一年数据
    var baseDate1 = {};
    baseDate1.name = "" + year;
    baseDate1.children = [];

    //设置第一个月之后月份的数据
    if (month <= 7) {
      if (month == 2 && day > 28) {
        baseDate1.children = baseYearDate.slice(month);
        baseDate.push(baseDate1);
      } else {
        //设置第一个月数据
        var baseMouthDate1 = baseYearDate[month - 1];
        var oneMouthDate = baseMouthDate1.children.slice(day - 1);
        var oneMouthOb = {};
        oneMouthOb.name = baseMouthDate1.name;
        oneMouthOb.children = oneMouthDate;
        baseDate1.children.push(oneMouthOb);

        temOb = baseYearDate.slice(month);
        for (var i = 0; i < temOb.length; i++) {
          baseDate1.children.push(temOb[i]);
        }

        baseDate.push(baseDate1);
      }
    } else {
      //设置第一年数据
      //设置第一个月数据
      //设置第一个月数据
      //设置第一个月数据
      var baseMouthDate1 = baseYearDate[month - 1];
      var oneMouthDate = baseMouthDate1.children.slice(day - 1);
      var oneMouthOb = {};
      oneMouthOb.name = baseMouthDate1.name;
      oneMouthOb.children = oneMouthDate;
      baseDate1.children.push(oneMouthOb);

      temOb = baseYearDate.slice(month);
      for (var i = 0; i < temOb.length; i++) {
        baseDate1.children.push(temOb[i]);
      }

      baseDate.push(baseDate1);

      //设置第二年数据
      var baseDate2 = {};
      baseDate2.name = "" + (year + 1);
      baseDate2.children = [];
      for (var i = 0; i < month - 7; i++) {
        baseDate2.children.push(baseYearDate[i]);
      }
      baseDate.push(baseDate2);
    }

    //初始化数据
    if (!isNull(baseDate)) {
      //年
      var yearHtml = '<select id="year">';
      for (var i = 0; i < baseDate.length; i++) {
        yearHtml +=
          '<option value="y' +
          baseDate[i].name +
          '">' +
          baseDate[i].name +
          "年</option>";
      }
      yearHtml += "</select>";
      $("#yeardiv").html(yearHtml);
      $("#year").searchableSelect();

      //第一年的月
      var monthHtml = '<select id="month">';
      for (var j = 0; j < baseDate[0].children.length; j++) {
        monthHtml +=
          '<option value="m' +
          baseDate[0].children[j].name +
          '">' +
          baseDate[0].children[j].name +
          "月</option>";
      }
      monthHtml += "</select>";
      $("#monthdiv").html(monthHtml);
      $("#month").searchableSelect();

      //第一年第一月的日
      var dayHtml = '<select id="day">';
      for (var k = 0; k < baseDate[0].children[0].children.length; k++) {
        dayHtml +=
          '<option value="d' +
          baseDate[0].children[0].children[k] +
          '">' +
          baseDate[0].children[0].children[k] +
          "日</option>";
      }
      dayHtml += "</select>";
      $("#daydiv").html(dayHtml);
      $("#day").searchableSelect();
    }

    if (doFunc && typeof doFunc == "function") {
      doFunc();
    }
  });
}

function getBankInfo() {
  toApi_toAcCg("S060288", { optType: "1" }, function (data) {
    var arr = [];
    isEnable = data.isEnable;
    if (data.isEnable == "Y") {
      for (var j = 0; j < data.limits.length; j++) {
        if (data.limits[j].cardType == "2") {
          arr.push(data.limits[j]);
        }
      }
      if (arr.length > 0) {
        bindCardInfos = arr;
        for (var i = 0; i < arr.length; i++) {
          bindCardLen = arr.length;

          var activateFlag = arr[i].activateFlag;
          var isExistsAgreement = arr[i].isExistsAgreement;
          var appendContents = "";
          var t_cardno = arr[i].cardno;
          t_cardno =
            t_cardno.substring(0, 4) +
            "********" +
            t_cardno.substring(t_cardno.length - 4, t_cardno.length);
          if (activateFlag == "0") {
            appendContents =
              "<div class='card-item'>" +
              "<div class='card-box bank-img  not-active' style='cursor:pointer'  id='box" +
              i +
              "' onclick='selOnCard(\"" +
              t_cardno +
              '",' +
              activateFlag +
              "," +
              isExistsAgreement +
              "," +
              i +
              "," +
              arr.length +
              "," +
              arr[i].normalWitham +
              ',"' +
              arr[i].cashAcctId +
              '",' +
              arr[i].witham +
              ',"' +
              arr[i].brchna +
              '","' +
              arr[i].cardno.substring(
                arr[i].cardno.length - 4,
                arr[i].cardno.length
              ) +
              "\")'><img src='" +
              arr[i].imgurl +
              "'/>" +
              "<p>" +
              arr[i].brchna +
              "</p>" +
              "<p class='font-10'>" +
              getCardType(arr[i].cardType) +
              "</p>" +
              "<i></i> <span>" +
              t_cardno +
              "</span> </div>" +
              "<div class='font-box'>" +
              "<p><span class='red'><i class='tips-icon'></i>该银行卡未激活，请激活之后再使用</span></p>" +
              "<p class='limit-p'><a href='javascript:void(0)' onclick='javascript:goBindCard(\"" +
              arr[i].cardno +
              '","' +
              arr[i].isExistsAgreement +
              '","' +
              arr[i].activateFlag +
              "\")' class='btn-blue-k'>去激活</a></p>" +
              "</div>" +
              "</div>";
          } else {
            if (!flag) {
              defaultNum = i;

              flag = true;
            }
            appendContents =
              "<div class='card-item'>" +
              "<div class='card-box bank-img' id='box" +
              i +
              "' style='cursor:pointer' onclick='selOnCard(\"" +
              t_cardno +
              '",' +
              activateFlag +
              "," +
              isExistsAgreement +
              "," +
              i +
              "," +
              arr.length +
              "," +
              arr[i].normalWitham +
              ',"' +
              arr[i].cashAcctId +
              '",' +
              arr[i].witham +
              ',"' +
              arr[i].brchna +
              '","' +
              arr[i].cardno.substring(
                arr[i].cardno.length - 4,
                arr[i].cardno.length
              ) +
              "\")'><img src='" +
              arr[i].imgurl +
              "'/><p>" +
              arr[i].brchna +
              "</p><p class='font-10'>" +
              getCardType(arr[i].cardType) +
              "</p><i></i>" +
              "<span>" +
              t_cardno +
              "</span>" +
              "</div>" +
              "<div class='font-box'>" +
              "<p class='blue-k-ment'>" +
              "<p class='balance' id='spTokeVi" +
              i +
              "'>此卡单笔最大取现金额<span id='spTokeMo" +
              i +
              "'>" +
              toThousands(arr[i].witham, 2) +
              "元</span></p>" +
              "<p class='balance none' id='noTokeVi" +
              i +
              "'>此卡当日最大可取现金额<span>" +
              toThousands(arr[i].normalWitham, 2) +
              "元</span></p>" +
              // "<p class='max-g'>"+arr[i].drawLevel_msg+"</p>"+
              "<p class='max-g'>取现等级：<span>" +
              EnumDrawLevelMsg[arr[i].drawLevel] +
              "</span></p>" +
              "</div>" +
              "</div>" +
              "<input id='hcarno" +
              i +
              "' type='hidden' value='" +
              t_cardno +
              "'>" +
              "<input id='hbankimg" +
              i +
              "' type='hidden' value='" +
              arr[i].imgurl +
              "'>" +
              "<input id='hcardtype" +
              i +
              "' type='hidden' value='" +
              arr[i].cardType +
              "'>" +
              "<input id='hbracna" +
              i +
              "' type='hidden' value='" +
              arr[i].brchna +
              "'>";
          }
          $("#bankCardInfor").append(appendContents);
        }
        for (var i = 0; i < arr.length; i++) {
          var activateFlag = arr[i].activateFlag;
          var isExistsAgreement = arr[i].isExistsAgreement;
          if (activateFlag == "1" && isExistsAgreement == "0") {
            if (!flag) {
              defaultNum = i;
              flag = true;
            }
          }
        }

        appendContents =
          "<div class='card-item last'>" +
          "<div class='card-box add' onclick='gotoAddCard()'>+ 新增其他支付方式" +
          "</div>" +
          "</div>";

        $("#bankCardInfor").append(appendContents);
        $("#box" + defaultNum).addClass("active");
        $("#box" + defaultNum).click();
        scnowitham = arr[defaultNum].normalWitham;
        UsepayCard = arr[defaultNum].cardno;
        defaultCardActivate =
          arr[defaultNum].activateFlag == "0" ||
          arr[defaultNum].isExistsAgreement == "0";
        defaultActivateFlag = arr[defaultNum].activateFlag == "0" ? "0" : "1";
        defaultisExistsAgreement =
          arr[defaultNum].isExistsAgreement == "0" ? "0" : "1";
        defaultCardno = arr[defaultNum].cardno;
        scwitham = arr[defaultNum].witham;
        cashAcctid = arr[defaultNum].cashAcctId;
      }
      toApi(
        "getwithdrawtype.tml?newVersion=1",
        function (data2) {
          // data2.outList.forEach(function(e){
          //     if(e.typeName == '快速取现'){
          //         if(!isNull(e.drsutm)&& !isNull(e.drsuam)){
          //             outAmount = e.drsutm;
          //             outMoney = e.drsuam;
          //             $("#tip").html('<div>预计<span>1分钟</span>内到账，今日快速取现剩余次数<span>'+outAmount+'</span>次</div>');
          //         }
          //     }
          // });
          for (var i = 0; i < data2.outList.length; i++) {
            if (data2.outList[i].typeName == "快速取现") {
              if (
                !isNull(data2.outList[i].drsutm) &&
                !isNull(data2.outList[i].drsuam)
              ) {
                outAmount = data2.outList[i].drsutm;
                outMoney = data2.outList[i].drsuam;
                $("#tip").html("<div>预计<span>1分钟</span>内到账</div>");
                //                        $("#tip").html('<div>预计<span>1分钟</span>内到账，今日快速取现剩余次数<span>'+outAmount+'</span>次</div>');
              }
            }
          }

          //每张银行卡的余额与drsuam的值比较，取小的那个
          for (var i = 0; i < bindCardLen; i++) {
            var str = $("#spTokeMo" + i).text();
            var numberStr = "";
            if (navigator.userAgent.indexOf("MSIE 8.0") > 0) {
              for (var i = 0; i < str.length - 1; i++) {
                if (str[i] != ",") {
                  numberStr += str[i];
                }
              }
              numberStr = Number(numberStr);
            } else {
              numberStr = Number(toNumber(str.substring(0, str.length - 1)));
            }
            if (numberStr > Number(outMoney)) {
              $("#spTokeMo" + i).text(toThousands(outMoney, 2) + "元");
            }
          }
          getWithdrawType(data2);
        },
        "getwithdrawtype",
        ""
      );
    } else {
      getOldBankInfo();
    }
  });
}
function getOldBankInfo() {
  toApi(
    "getbankwhitelist.tml",
    function (data) {
      if (data.bindCardInfos.length > 0) {
        bindCardInfos = data.bindCardInfos;
        for (var i = 0; i < data.bindCardInfos.length; i++) {
          bindCardLen = data.bindCardInfos.length;

          var activateFlag = data.bindCardInfos[i].activateFlag;
          var isExistsAgreement = data.bindCardInfos[i].isExistsAgreement;
          var appendContents = "";
          var t_cardno = data.bindCardInfos[i].cardno;
          t_cardno =
            t_cardno.substring(0, 4) +
            "********" +
            t_cardno.substring(t_cardno.length - 4, t_cardno.length);
          if (activateFlag == "0") {
            appendContents =
              "<div class='card-item'>" +
              "<div class='card-box bank-img  not-active' style='cursor:pointer'  id='box" +
              i +
              "' onclick='selOnCard(\"" +
              t_cardno +
              '",' +
              activateFlag +
              "," +
              isExistsAgreement +
              "," +
              i +
              "," +
              data.bindCardInfos.length +
              "," +
              data.bindCardInfos[i].normalWitham +
              ',"' +
              data.bindCardInfos[i].cashAcctid +
              '",' +
              data.bindCardInfos[i].witham +
              ',"' +
              data.bindCardInfos[i].brchna +
              '","' +
              data.bindCardInfos[i].cardno.substring(
                data.bindCardInfos[i].cardno.length - 4,
                data.bindCardInfos[i].cardno.length
              ) +
              "\")'><img src='" +
              apiURL +
              "img/getbankImg/" +
              data.bindCardInfos[i].imgurl +
              "'/>" +
              "<p>" +
              data.bindCardInfos[i].brchna +
              "</p>" +
              "<p class='font-10'>" +
              getCardType(data.bindCardInfos[i].cardType) +
              "</p>" +
              "<i></i> <span>" +
              t_cardno +
              "</span> </div>" +
              "<div class='font-box'>" +
              "<p><span class='red'><i class='tips-icon'></i>该银行卡未激活，请激活之后再使用</span></p>" +
              "<p class='limit-p'><a href='javascript:void(0)' onclick='javascript:goBindCard(\"" +
              data.bindCardInfos[i].cardno +
              '","' +
              data.bindCardInfos[i].isExistsAgreement +
              '","' +
              data.bindCardInfos[i].activateFlag +
              "\")' class='btn-blue-k'>去激活</a></p>" +
              "</div>" +
              "</div>";
          } else {
            if (!flag) {
              defaultNum = i;
              flag = true;
            }
            appendContents =
              "<div class='card-item'>" +
              "<div class='card-box bank-img' id='box" +
              i +
              "' style='cursor:pointer' onclick='selOnCard(\"" +
              data.bindCardInfos[i].cardno +
              '",' +
              activateFlag +
              "," +
              isExistsAgreement +
              "," +
              i +
              "," +
              data.bindCardInfos.length +
              "," +
              data.bindCardInfos[i].normalWitham +
              ',"' +
              data.bindCardInfos[i].cashAcctid +
              '",' +
              data.bindCardInfos[i].witham +
              ',"' +
              data.bindCardInfos[i].brchna +
              '","' +
              data.bindCardInfos[i].cardno.substring(
                data.bindCardInfos[i].cardno.length - 4,
                data.bindCardInfos[i].cardno.length
              ) +
              "\")'><img src='" +
              apiURL +
              "img/getbankImg/" +
              data.bindCardInfos[i].imgurl +
              "'/><p>" +
              data.bindCardInfos[i].brchna +
              "</p><p class='font-10'>" +
              getCardType(data.bindCardInfos[i].cardType) +
              "</p><i></i>" +
              "<span>" +
              t_cardno +
              "</span>" +
              "</div>" +
              "<div class='font-box'>" +
              "<p class='blue-k-ment'>" +
              "<p class='balance' id='spTokeVi" +
              i +
              "'>此卡单笔最大取现金额<span id='spTokeMo" +
              i +
              "'>" +
              toThousands(data.bindCardInfos[i].witham, 2) +
              "元</span></p>" +
              "<p class='balance none' id='noTokeVi" +
              i +
              "'>此卡当日最大可取现金额<span>" +
              toThousands(data.bindCardInfos[i].normalWitham, 2) +
              "元</span></p>" +
              // "<p class='max-g'>"+data.bindCardInfos[i].drawLevel_msg+"</p>"+
              "<p class='max-g'>取现等级：<span>" +
              EnumDrawLevelMsg[data.bindCardInfos[i].drawLevel] +
              "</span></p>" +
              "</div>" +
              "</div>" +
              "<input id='hcarno" +
              i +
              "' type='hidden' value='" +
              data.bindCardInfos[i].cardno +
              "'>" +
              "<input id='hbankimg" +
              i +
              "' type='hidden' value='" +
              data.bindCardInfos[i].imgurl +
              "'>" +
              "<input id='hcardtype" +
              i +
              "' type='hidden' value='" +
              data.bindCardInfos[i].cardType +
              "'>" +
              "<input id='hbracna" +
              i +
              "' type='hidden' value='" +
              data.bindCardInfos[i].brchna +
              "'>";
          }
          $("#bankCardInfor").append(appendContents);
        }
        for (var i = 0; i < data.bindCardInfos.length; i++) {
          var activateFlag = data.bindCardInfos[i].activateFlag;
          var isExistsAgreement = data.bindCardInfos[i].isExistsAgreement;
          if (activateFlag == "1" && isExistsAgreement == "0") {
            if (!flag) {
              defaultNum = i;
              flag = true;
            }
          }
        }

        appendContents =
          "<div class='card-item last'>" +
          "<div class='card-box add' onclick='gotoAddCard()'>+ 新增其他支付方式" +
          "</div>" +
          "</div>";
        $("#bankCardInfor").append(appendContents);
        $("#box" + defaultNum).addClass("active");
        $("#box" + defaultNum).click();
        scnowitham = data.bindCardInfos[defaultNum].normalWitham;

        UsepayCard = data.bindCardInfos[defaultNum].cardno;
        defaultCardActivate =
          data.bindCardInfos[defaultNum].activateFlag == "0" ||
          data.bindCardInfos[defaultNum].isExistsAgreement == "0";
        defaultActivateFlag =
          data.bindCardInfos[defaultNum].activateFlag == "0" ? "0" : "1";
        defaultisExistsAgreement =
          data.bindCardInfos[defaultNum].isExistsAgreement == "0" ? "0" : "1";
        defaultCardno = data.bindCardInfos[defaultNum].cardno;
        scwitham = data.bindCardInfos[defaultNum].witham;
        cashAcctid = data.bindCardInfos[defaultNum].cashAcctid;
      }
      toApi(
        "getwithdrawtype.tml?newVersion=1",
        function (data2) {
          // data2.outList.forEach(function(e){
          //     if(e.typeName == '快速取现'){
          //         if(!isNull(e.drsutm)&& !isNull(e.drsuam)){
          //             outAmount = e.drsutm;
          //             outMoney = e.drsuam;
          //             $("#tip").html('<div>预计<span>1分钟</span>内到账，今日快速取现剩余次数<span>'+outAmount+'</span>次</div>');
          //         }
          //     }
          // });
          for (var i = 0; i < data2.outList.length; i++) {
            if (data2.outList[i].typeName == "快速取现") {
              if (
                !isNull(data2.outList[i].drsutm) &&
                !isNull(data2.outList[i].drsuam)
              ) {
                outAmount = data2.outList[i].drsutm;
                outMoney = data2.outList[i].drsuam;
                $("#tip").html("<div>预计<span>1分钟</span>内到账</div>");
                //                        $("#tip").html('<div>预计<span>1分钟</span>内到账，今日快速取现剩余次数<span>'+outAmount+'</span>次</div>');
              }
            }
          }

          //每张银行卡的余额与drsuam的值比较，取小的那个
          for (var i = 0; i < bindCardLen; i++) {
            var str = $("#spTokeMo" + i).text();
            var numberStr = "";
            if (navigator.userAgent.indexOf("MSIE 8.0") > 0) {
              for (var i = 0; i < str.length - 1; i++) {
                if (str[i] != ",") {
                  numberStr += str[i];
                }
              }
              numberStr = Number(numberStr);
            } else {
              numberStr = Number(toNumber(str.substring(0, str.length - 1)));
            }
            if (numberStr > Number(outMoney)) {
              $("#spTokeMo" + i).text(toThousands(outMoney, 2) + "元");
            }
          }
          getWithdrawType(data2);
        },
        "getwithdrawtype",
        ""
      );
    },
    "getbankwhitelist",
    ""
  );
}
